import React, {useContext} from 'react';
import Context from '../../contexts/MarketPerformanceContext';
import {truncateNumber} from '../../utilities/Utils';
import {marketsView} from '../../../primary/components/analytics/events/markets';
import {setupAnalytics} from '../../../primary/components/analytics/default';

const analytics = setupAnalytics();

function TopIndices() {
    const context = useContext(Context);

    return (
        <div className="top-indices">
            <table className="table table-top-indices">
                <thead>
                    <tr>
                        <th width="38">&nbsp;</th>
                        <th className="text-left">Index name</th>
                        <th className="text-right combined-values">
                            <p className="text-nowrap mb-0">Market value</p>
                            <p className="text-plain text-nowrap d-md-none mb-sm-0">Change (&#37;)</p>
                        </th>
                        <th className="text-right d-none d-md-table-cell">Change</th>
                        <th className="text-right text-plain d-none d-md-table-cell">&#37;</th>
                        <th width="32">&nbsp;</th>
                    </tr>
                </thead>
                <tbody>
                    {context.state.marketIndex.indices.map((index, key) => {
                        const isCurrent = index.instrumentId === context.state.currentIndexId;

                        return (
                            <tr className={`${(isCurrent ? 'table-row-active' : '')}`} onClick={() => { context.setCurrentIndex(index.instrumentId); }} key={key}>
                                <td className="input-column" width="38">
                                    <div className="custom-control custom-radio">
                                        <input
                                            type="radio"
                                            id={`index${key}`}
                                            name="currentIndex"
                                            className="custom-control-input"
                                            value={index.instrumentId}
                                            checked={isCurrent}
                                            onChange={() => { context.setCurrentIndex(index.instrumentId); }}
                                        />
                                        <label className="custom-control-label" htmlFor={`index${key}`}>&nbsp;</label>
                                    </div>
                                </td>
                                <td className="column-primary">
                                    {index.name}
                                </td>
                                <td className="text-right">
                                    <p className="text-nowrap mb-0">{truncateNumber(index.closeValue.amount)} {index.closeValue.currency}</p>
                                    <p className="text-plain text-nowrap text-nowrap d-md-none">
                                        {`${index.changeValue.amount > 0 ? '+' : ''}${truncateNumber(index.changeValue.amount)} ${index.changeValue.currency} (${index.changePercentage.toFixed(2)}%)`}
                                    </p>
                                </td>
                                <td className="text-right d-none d-md-table-cell">{`${index.changeValue.amount > 0 ? '+' : ''}${truncateNumber(index.changeValue.amount)} ${index.changeValue.currency}`}</td>
                                <td className="text-right text-plain d-none d-md-table-cell">{`${index.changePercentage > 0 ? '+' : ''}${index.changePercentage.toFixed(2)}%`}</td>
                                <td className="indicator" width="32">
                                    <span className={`${(index.changePercentage > 0 ? 'icon arrow-solid-head-green' : (index.changePercentage < 0 ? 'icon arrow-solid-head-red arrow-down' : 'icon dash'))}`}>
                                        &nbsp;
                                    </span>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
            {
                context.state.marketIndex.otherIndicesExist
                    ? <div className="outbound clearfix">
                        <button
                            type="button"
                            className='outbound-link pull-right other-indices'
                            onClick={() => {
                                context.getFullIndices(context.state.currentTabId);
                                if (context.state.currentTabId != null) {
                                    analytics.trackEvent(marketsView({title: `View Other ${ context.state.currentTabId?.toUpperCase() } Indices`}));
                                }
                            }
                        }>
                            Other Indices <span className="icon chevron-blue chevron-right" />
                        </button>
                    </div>
                    : ''
            }
        </div>
    );
}

export default TopIndices;
